/**
 * Open and close the sub menus on the open mobile menu
 */

const subMenuToggle = ($) => {
	$(".menu-item-has-children").on("click", function (e) {
		// since we have links inside of a clickable item, we first need to check where the source
		// of the click is coming from, as the event from clicking the a tag will bubble up and fire
		// the function on the parent
		if ($(e.target).is("li")) {
			$(this).toggleClass("js-open-sub-menu");
		} else {
			e.stopPropagation();
		}
	});
};

export default subMenuToggle;
